/**
 * Section A4 Service
 * A.4.專案位置 API 服務
 *
 * 注意: axios 攔截器會自動從 localStorage 讀取 txn_token 並添加到所有請求的 header
 * Service 層不需要手動傳遞 txn_token 參數
 */

import axios from '../api/axios';
import { SectionA4, SectionA4Update } from '../types/section_a4';

const BASE_URL = '/api/section-a4';

/**
 * 根據專案 ID 取得 A.4 資料
 * axios 攔截器會自動添加 X-Txn-Token header
 */
export const getSectionA4ByProject = async (projectId: number): Promise<SectionA4 | null> => {
  const response = await axios.get<SectionA4>(`${BASE_URL}/by-project/${projectId}`);
  return response.data;
};

/**
 * 更新或建立 A.4 資料
 * 如果不存在會自動建立
 * axios 攔截器會自動添加 X-Txn-Token header
 */
export const updateSectionA4 = async (projectId: number, data: SectionA4Update): Promise<SectionA4> => {
  const response = await axios.put<SectionA4>(`${BASE_URL}/${projectId}`, data);
  return response.data;
};

/**
 * 刪除 A.4 資料
 * axios 攔截器會自動添加 X-Txn-Token header
 */
export const deleteSectionA4 = async (projectId: number): Promise<void> => {
  await axios.delete(`${BASE_URL}/${projectId}`);
};

export default {
  getSectionA4ByProject,
  updateSectionA4,
  deleteSectionA4
};
